import React, { forwardRef } from 'react';
import css from '../../utils/css';
import { BoxProps } from '../../Box';
import { InputProps } from '../Input';
import { TextInputBase } from '../TextInputBase';

export interface TextInputProps extends InputProps, BoxProps {
  type?: string;
}

/**
 * @deprecated  use `TextInput` from `genesis-core` instead
 */

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (props, ref) => (
    <TextInputBase
      ref={ref}
      height="three"
      type="text"
      css={css({
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
      })}
      {...props}
    />
  )
);

TextInput.displayName = 'TextInput';
